export default "__VITE_ASSET__CudCBeXu__"